export default __webpack_public_path__ + "static/media/151-attached.23f63040.png";